module.exports = __webpack_public_path__ + "static/media/back-ground2.15fb70a1.jpeg";